export const GET_PEOPLE = "GET_PEOPLE";
export const GET_CHARACTER = "GET_CHARACTER";
export const SET_FAVOURITE = "SET_FAVOURITE";
export const UNSET_FAVOURITE = "UNSET_FAVOURITE";
